import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Layout, Main } from '../../../components'
import {
  getStep,
  getUser,
  setOrganizationDetails,
  setStep,
  setUserInformations,
} from '../Create/state'
import { useQueryParams } from '../../../hooks/useQueryParams'
import { CreateSteps } from '../Create/CreateSteps'
import { Finished } from '../Create/Finished'
import { Creating } from '../Create/Creating'
import { JoinableTeams } from '../Create/JoinableTeams'
import { useProvideStepAnalytics } from '../../../hooks/useStepAnalytics'
import { Paths } from '../constants'
import { FormattedMessage } from 'react-intl'

type CreateFromOauthUrlQueryParams = {
  displayName?: string
  photoURL?: string
  isPopularDomain?: string
  cacheKey?: string
  organizationName?: string
  email?: string
  loginOrigin?: string
  fromSuper?: string
}

export function OrganizationJoinFromOauth({
  superEnabled = false,
}: {
  superEnabled?: boolean
}) {
  const history = useHistory()
  const dispatch = useDispatch()
  const user = useSelector(getUser)
  const step = useSelector(getStep)
  const [path, setPath] = useState(Paths.Create)

  const {
    cacheKey,
    displayName,
    photoURL,
    isPopularDomain,
    organizationName,
    email,
    loginOrigin,
    fromSuper,
  } = useQueryParams<CreateFromOauthUrlQueryParams>()

  useEffect(() => {
    dispatch(
      setUserInformations(
        {
          photoURL,
          displayName,
          cacheKey,
          email,
        },
        false
      )
    )
    dispatch(
      setOrganizationDetails(
        {
          name: organizationName,
          isPopularDomain: Boolean(isPopularDomain),
        },
        false
      )
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!user.cacheKey) {
      return
    }

    setPath(Paths.Join)
    dispatch(setStep(CreateSteps.JoinableTeams))
  }, [dispatch, history, user])

  useProvideStepAnalytics(path)

  const getComponent = () => {
    switch (step) {
      case CreateSteps.JoinableTeams: {
        return (
          <JoinableTeams
            onCreateAnyway={() => {
              setPath(Paths.Create)
              dispatch(setStep(CreateSteps.Creating))
            }}
          />
        )
      }
      case CreateSteps.Creating:
        return <Creating loginOrigin={loginOrigin} />
      case CreateSteps.Finished:
        return <Finished />
      default:
        return (
          <Main.Container>
            <Main.Title>
              <FormattedMessage
                id="boarding.loading"
                defaultMessage="Loading..."
                values={{}}
              />
            </Main.Title>
          </Main.Container>
        )
    }
  }

  return (
    <Layout superEnabled={!!fromSuper || superEnabled}>{getComponent()}</Layout>
  )
}
